import { motion } from "framer-motion";
import Logo from "./icons/Logo";

export default function LoadingPage() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="text-[#3C3C3B]"
        >
          <Logo width="180" height="48" />
        </motion.div>
      </motion.div>
    </div>
  );
}
